import { colorPalette } from '@shared/config/colorsConfig';
import { typography } from '@shared/config/typographyConfig';

const LINE_HEIGHT = 26;
const PADDING_VERTICAL = 8;
const BORDER_WIDTH = 1;

export const CHAT_COMPOSER_INPUT_STYLE = {
    backgroundColor: colorPalette.white,
    borderWidth: BORDER_WIDTH,
    borderColor: colorPalette.gray[400],
    borderRadius: 8,
    fontSize: typography.fontSize.md,
    lineHeight: LINE_HEIGHT,
    paddingTop: PADDING_VERTICAL,
    paddingBottom: PADDING_VERTICAL,
    minHeight: 2 * LINE_HEIGHT + 2 * PADDING_VERTICAL + 2 * BORDER_WIDTH,
    maxHeight: 144,
    textAlignVertical: 'top',
    paddingEnd: 52,
} as const;

export const CHAT_COMPOSER_ICON_SIZE = 20;
